// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"df08b943","40":"0e3e7537"}[chunkId] + ".chunk.js";
};